/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { FC } from "react";
import NewDynamicDoctorStepperForm from "../forms/doctor/DynamicDoctorStepperForm";
import { NewDoctorStepperFormProps } from "interfaces";

/**
 * Content component for creating a new doctor or head nurse provider.
 * Uses a dynamic stepper form to guide through the provider registration process,
 * including personal information, credentials, and specializations.
 * @param {NewDoctorStepperFormProps} props - Component props including isDoctor and isHeadNurse flags
 * @returns {React.ReactElement} The new doctor content component
 */
const NewDoctorDataContent: FC<NewDoctorStepperFormProps> = ({ isDoctor, isHeadNurse }) => {
  return <NewDynamicDoctorStepperForm isDoctor={isDoctor} isHeadNurse={isHeadNurse} />;
};

export default NewDoctorDataContent;